const styles = theme => ({

  pageContainer: {
    width: "100%",
    height: "100vh",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    background: "#f4f7f6"
  },

  topBar: {
    height: "72px",
    minHeight: "72px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 24px",
    boxSizing: "border-box",
    background: "#ffffff",
    borderBottom: "1px solid #e5ece9",
    boxShadow: "0 3px 16px rgba(20, 45, 38, 0.06)",
    position: "relative",
    zIndex: 10
  },

  topBarLeft: {
    display: "flex",
    alignItems: "center",
    gap: "12px"
  },

  brandMark: {
    width: "42px",
    height: "42px",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#173f34",
    color: "#ffffff",
    fontSize: "14px",
    fontWeight: 800,
    letterSpacing: "0.5px",
    boxShadow: "0 5px 14px rgba(23, 63, 52, 0.18)"
  },

  brandName: {
    fontSize: "15px",
    fontWeight: 800,
    color: "#16332b",
    letterSpacing: "-0.2px"
  },

  brandSubtitle: {
    marginTop: "2px",
    fontSize: "11px",
    color: "#84938e",
    fontWeight: 500
  },

  posBadge: {
    marginLeft: "8px",
    padding: "7px 11px",
    borderRadius: "8px",
    background: "#eef7f3",
    color: "#16845b",
    fontSize: "10px",
    fontWeight: 800,
    letterSpacing: "0.5px"
  },

  topBarRight: {
    display: "flex",
    alignItems: "center",
    gap: "14px"
  },

  connectionStatus: {
    display: "flex",
    alignItems: "center",
    gap: "7px",
    padding: "8px 11px",
    borderRadius: "9px",
    background: "#f6faf8",
    border: "1px solid #e3eee9",
    color: "#5b7068",
    fontSize: "11px",
    fontWeight: 600
  },

  statusDot: {
    width: "7px",
    height: "7px",
    borderRadius: "50%",
    background: "#22c55e",
    boxShadow: "0 0 0 3px rgba(34, 197, 94, 0.12)"
  },

  cashierRole: {
    marginTop: "2px",
    fontSize: "10px",
    color: "#87958f"
  },

  chevron: {
    marginLeft: "3px",
    fontSize: "9px",
    color: "#7c8c86"
  },
  root: {
    width: "100%",
    height: "100%",
    minHeight: "calc(100vh - 64px)",
    boxSizing: "border-box",
    background: "#f4f7f6",
    padding: 0
  },

  flexContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    minHeight: "calc(100vh - 64px)",
    height: "calc(100vh - 72px)",
    overflow: "hidden",
    boxSizing: "border-box",
    background: "#f4f7f6"
  },

  pos: {
    width: "43%",
    minWidth: "440px",
    maxWidth: "590px",
    height: "100%",
    margin: 0,
    padding: "18px",
    boxSizing: "border-box",
    background: "#ffffff",
    borderLeft: "1px solid #e4ebe8",
    boxShadow: "-8px 0 30px rgba(20, 45, 38, 0.06)",
    overflowY: "auto",
    order: 2
  },

  posContent: {
    minHeight: "100%",
    margin: 0
  },

  items: {
    flex: 1,
    height: "100%",
    minWidth: 0,
    margin: 0,
    padding: "24px",
    boxSizing: "border-box",
    overflowY: "auto",
    order: 1,
    background: "#f4f7f6"
  },

  header: {
    height: "68px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 24px",
    boxSizing: "border-box",
    background: "#ffffff",
    borderBottom: "1px solid #e4ebe8",
    boxShadow: "0 2px 12px rgba(20, 45, 38, 0.04)",
    position: "relative",
    zIndex: 5
  },

  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: "12px"
  },

  title: {
    margin: 0,
    fontSize: "21px",
    fontWeight: 800,
    color: "#16332b",
    letterSpacing: "-0.4px"
  },

  subtitle: {
    margin: "3px 0 0",
    fontSize: "12px",
    color: "#7a8a85"
  },

  cashier: {
    display: "flex",
    alignItems: "center",
    gap: "9px",
    padding: "8px 13px",
    borderRadius: "12px",
    background: "#f1f7f4",
    border: "1px solid #e0ebe6",
    color: "#25473d"
  },

  cashierIcon: {
    width: "30px",
    height: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    background: "#dcefe7",
    fontSize: "15px"
  },

  cashierName: {
    fontWeight: 700,
    fontSize: "13px",
    color: "#21443a"
  },

  searchWrapper: {
    width: "320px"
  },

  catalogHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "16px"
  },

  catalogTitle: {
    margin: 0,
    fontSize: "21px",
    fontWeight: 800,
    color: "#16332b",
    letterSpacing: "-0.3px"
  },

  catalogSubtitle: {
    margin: "5px 0 0",
    fontSize: "12px",
    color: "#7a8a85"
  },

  productGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(165px, 1fr))",
    gap: "16px"
  },

  categoryBar: {
    display: "flex",
    gap: "8px",
    marginBottom: "20px",
    flexWrap: "wrap",
    maxHeight: "110px",
    overflowY: "auto",
    padding: "4px 2px"
  },

  categoryButton: {
    border: "1px solid #dce7e2",
    borderRadius: "10px",
    padding: "9px 15px",
    background: "#ffffff",
    color: "#52655e",
    fontWeight: 600,
    cursor: "pointer",
    transition: "all 0.2s ease"
  },

  categoryButtonActive: {
    border: "1px solid #173f34",
    borderRadius: "10px",
    padding: "9px 15px",
    background: "#173f34",
    color: "#ffffff",
    fontWeight: 700,
    cursor: "pointer",
    boxShadow: "0 4px 12px rgba(23, 63, 52, 0.18)"
  },

  catalogCard: {
    background: "#ffffff",
    border: "1px solid #e5ece9",
    borderRadius: "16px",
    padding: "16px",
    boxShadow: "0 3px 14px rgba(20, 45, 38, 0.045)"
  }
});

export default styles;

